import React from 'react';
import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayBool = (value, t) =>
  value === true || value === false
    ? value
      ? t('Yes')
      : t('No')
    : display(value);

const displayDate = (value) =>
  value && moment(value).isValid() ? moment(value).format('DD MMMM YYYY') : '—';

const fileLink = (url, name) =>
  url ? (
    <a href={url} target='_blank' rel='noreferrer'>
      {name || url}
    </a>
  ) : (
    '—'
  );

const htmlField = (html) =>
  html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : '—';

const headerImagesField = (images) => {
  if (!images?.length) {
    return '—';
  }
  return (
    <>
      {images.map((img, index) => (
        <React.Fragment key={img.id || index}>
          {index > 0 && ', '}
          {fileLink(img.url, img.filename)}
        </React.Fragment>
      ))}
    </>
  );
};

export const getBrandViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const siteCategoryTitles =
    item.site_categories?.map((c) => c.title || c.title_it).join(', ') || '—';

  return [
    {
      title: t('Info'),
      fields: [{ text: t('Titolo'), value: display(item.title) }],
    },
    {
      title: t('Files'),
      fields: [
        {
          text: t('Logo'),
          value: fileLink(item.allData?.logo, item.allData?.logo_name),
        },
        {
          text: t('Header Immagine'),
          value: headerImagesField(item.allData?.header_images),
        },
        // {
        //   text: t('Offerte header image'),
        //   value: fileLink(
        //     item.allData?.header_image_offers,
        //     item.allData?.header_image_offers_name,
        //   ),
        // },
      ],
    },
    {
      title: t('Date'),
      fields: [
        { text: t('Data inizio'), value: displayDate(item.date_from) },
        { text: t('Data fine'), value: displayDate(item.date_to) },
      ],
    },
    {
      title: t('Descrizione Corta'),
      fields: [
        {
          text: t('Descrizione Corta IT'),
          value: htmlField(item.description_short_it),
        },
        {
          text: t('Descrizione Corta EN'),
          value: htmlField(item.description_short_en),
        },
        {
          text: t('Descrizione Corta FR'),
          value: htmlField(item.description_short_fr),
        },
      ],
    },
    {
      title: t('Descrizione'),
      fields: [
        {
          text: t('Descrizione IT'),
          value: htmlField(item.description_it),
        },
        {
          text: t('Descrizione EN'),
          value: htmlField(item.description_en),
        },
        {
          text: t('Descrizione FR'),
          value: htmlField(item.description_fr),
        },
      ],
    },
    {
      title: t('Shop'),
      fields: [{ text: t('Insegna'), value: display(item.company) }],
    },
    {
      title: t('Categoria Sito'),
      fields: [
        { text: t('Categoria'), value: siteCategoryTitles },
        { text: t('ID'), value: display(item.mapedin_id) },
        { text: t('Orari'), value: display(item.working_hours) },
        {
          text: t('On Carousel'),
          value: displayBool(item.on_carousel, t),
        },
      ],
    },
    {
      title: t('Opzioni'),
      fields: [
        { text: t('Stato'), value: display(item.published) },
        { text: t('Retail approvato'), value: display(item.retail_approved) },
        {
          text: t('Marketing approvato'),
          value: display(item.marketing_approved),
        },
      ],
    },
  ];
};
